(() => {
  const init = () => document.querySelectorAll('[data-pricing-hub]').forEach(root => {
    if (root.dataset.pricingReady) return;
    root.dataset.pricingReady = 'true';
    const tabs = [...root.querySelectorAll('[data-pricing-tabs] a')];
    const panels = [...root.querySelectorAll('[data-pricing-panel]')];
    root.querySelector('[data-pricing-tabs]').setAttribute('role','tablist');
    const select = (id, focus = false) => {
      if (!panels.some(p => p.id === id)) id = 'hourly';
      tabs.forEach(tab => {
        const active = tab.getAttribute('href') === '#' + id;
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',tab.hash.slice(1));
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(panel => {
        panel.setAttribute('role','tabpanel');
        panel.tabIndex = 0;
        panel.hidden = panel.id !== id;
      });
    };
    tabs.forEach((tab,index) => {
      tab.addEventListener('click',event => {
        event.preventDefault();
        history.replaceState(null,'',tab.hash);
        select(tab.hash.slice(1));
      });
      tab.addEventListener('keydown',event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        history.replaceState(null,'',tabs[next].hash);
        select(tabs[next].hash.slice(1),true);
      });
    });
    select(location.hash.slice(1));
    window.addEventListener('hashchange',() => select(location.hash.slice(1)));
    const money = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
    const fee = root.querySelector('#sp-entry-fee');
    const entries = root.querySelector('#sp-entries');
    const eventOutput = () => {
      const valid = fee.value.trim() !== '' && entries.value.trim() !== '' && fee.checkValidity() && entries.checkValidity();
      const gross = Number(fee.value) * Number(entries.value);
      const values = {'[data-event-gross]':gross,'[data-event-retained]':gross,'[data-event-net]':gross-2500,'[data-event-share]':gross*.5};
      Object.entries(values).forEach(([selector,value]) => {root.querySelector(selector).textContent = valid ? money.format(value) : '—';});
    };
    fee.addEventListener('input',eventOutput);
    entries.addEventListener('input',eventOutput);
    const onsite = root.querySelector('#sp-onsite-hours');
    const onsiteOutput = () => {
      const valid = onsite.value.trim() !== '' && onsite.checkValidity() && Number.isSafeInteger(Number(onsite.value));
      root.querySelector('[data-onsite-total]').textContent = valid ? money.format(Number(onsite.value)*50) : root.dataset.invalid;
    };
    onsite.addEventListener('input',onsiteOutput);
    eventOutput();onsiteOutput();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();